import {
  GET_EXAM,
  GET_EXAM_SUCCESS,
  GET_EXAM_CLEAN,
  GET_EXAM_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  exam: undefined,
}

const ExamGet = (state = initialState, action) => {
  switch (action.type) {
    case GET_EXAM:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_EXAM_SUCCESS:
      state = {
        ...state,
        exam: action.payload.exam,
        loading: false,
        done: true,
      }
      break
    case GET_EXAM_CLEAN:
      state = initialState
      break
    case GET_EXAM_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default ExamGet
